<template>
  <div class="p-12">
    <div class="grid grid-cols-3 gap-12">
      <PageCard v-for="page in facebookPages" :key="page.id" :page="page" />
    </div>
  </div>
</template>

<script>
import { accountFacebookPagesClient } from '@/api/clients';
import PageCard from './socialConnections/components/PageCard.vue';

export default {
  components: {
    PageCard,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      facebookPages: [],
    };
  },
  created() {
    this.getFacebookPages();
  },
  methods: {
    async getFacebookPages() {
      if (this.loading) return;

      this.loading = true;

      try {
        const response = await accountFacebookPagesClient.list(this.accountId);
        this.facebookPages = response.data;
      } catch (error) {
        //
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
